export const createFilterWidthMap = (classMap: Record<string, string[] | string>): Record<string, string> => {
  const filterWidthMap: Record<string, string> = {}
  Object.keys(classMap).forEach(classKey => {
    const value = classMap[classKey]
    const valueArr: string[] = Array.isArray(value) ? value : [value]
    valueArr.forEach(filter => {
      filterWidthMap[filter] = classKey
    })
  })
  return filterWidthMap
}
